var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8052 1.03409C12.0531 0.786226 12.0661 0.397407 11.8344 0.165639C11.6026 -0.06613 11.2138 -0.0530824 10.9659 0.194781L6.02914 5.13155L1.41294 0.515351C1.18118 0.283582 0.792357 0.29663 0.544493 0.544493C0.29663 0.792357 0.283582 1.18118 0.515351 1.41294L5.13155 6.02914L0.194781 10.9659C-0.0530824 11.2138 -0.06613 11.6026 0.165639 11.8344C0.397407 12.0661 0.786226 12.0531 1.03409 11.8052L5.97086 6.86845L10.5871 11.4846C10.8188 11.7164 11.2076 11.7034 11.4555 11.4555C11.7034 11.2076 11.7164 10.8188 11.4846 10.5871L6.86845 5.97086L11.8052 1.03409Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.23a69f765c7d3f3a2f9060cf3d097be7.svg";
export { ForwardRef as ReactComponent };